// src/features/release-notes/routes.ts
//
// Where «Ir a la pantalla» leads for a screen key (roommatik.analytics `ManualScreens.Known`). A key
// with no route here — a detail page that needs an id — shows no button.

const SCREEN_ROUTES: Readonly<Record<string, string>> = {
  arrivals: '/arrivals',
  reservations: '/reservations',
  'live-board': '/live-board',
  summary: '/summary',
  operacion: '/operacion',
  satisfaction: '/satisfaction',
  channels: '/channels',
  dispensers: '/dispensers',
  durations: '/durations',
  'hotels-overview': '/hotels-overview',
  benchmark: '/benchmark',
  payments: '/payments',
  reconciliation: '/reconciliation',
  'error-monitor': '/error-monitor',
  events: '/events',
  alerts: '/alerts',
  logs: '/logs',
  'error-definitions': '/error-definitions',
  devices: '/devices',
  control: '/control',
  status: '/status',
  simulators: '/simulators',
  'admin-options': '/admin-options',
  users: '/users',
  fit: '/fit',
  developers: '/developers',
  assistant: '/assistant',
};

export const screenRoute = (screen: string | null | undefined): string | null =>
  (screen && SCREEN_ROUTES[screen]) || null;
